<template>
  <div>
    <aha-section>
      <template #header>
        <h5>Referral history</h5>
      </template>
      <template #body>
        <div class="flex flex-wrap">
          <div class="w-full">
            <table class="w-full payment-table">
              <thead>
                <tr class="text-left">
                  <th>
                    #
                  </th>
                  <th>
                    Name
                  </th>
                  <th>
                    Sign-up Date
                  </th>
                  <th>
                    Referral Status
                  </th>
                  <th>
                    Credit Earned
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  :key="index"
                  v-for="(item, index) in referrees"
                  style="width:100%;"
                  class="table-data-body"
                >
                  <td data-header="#">
                    {{ index + 1 }}
                  </td>
                  <td data-header="Full name">
                    {{ item.firstName }} {{ item.lastName }}
                  </td>
                  <td data-header="Joind At">
                    {{ item.createdAt | dateTime }}
                  </td>
                  <td data-header="Status">
                    <span v-if="item.referralAwardStatus">Completed</span>
                    <span v-else>Signed up</span>
                  </td>
                  <td data-header="" class="font-bold">
                    <span
                      v-if="!item.referralAwardStatus || item.referralAwardStatus === 'discard'"
                    >
                      0.00 USD
                    </span>
                    <span v-else class="text-green-50">
                      + 5.00 USD
                      <img
                        src="@/assets/images/icon/money.svg"
                        class="inline-block relative bottom-0.5"
                      >
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
    </aha-section>
  </div>
</template>

<script>
import UserApi from '@/api/user'

export default {
  components: {
  },
  data() {
    return {
      referrees: [],
    }
  },
  async mounted() {
    const res = await UserApi.getReferrees()
    this.referrees = res.users
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>

.payment-table {
  @apply border-collapse;
}

.payment-table tbody tr {
  &:nth-child(odd) {
    @apply bg-secondary-10;
    td:first-child {
      @apply rounded-l-md;
    }
    td:last-child {
      @apply rounded-r-md;

    }
  }
}

.payment-table td,
.payment-table th {
  @apply py-5 px-4;
}

.payment-table th {
  @apply text-left pt-0;

}

@media screen and (max-width:1024px) {
  .payment-table {
    @apply mx-auto w-full;
    border-spacing: 0;
  }
  .payment-table thead {
    @apply absolute p-0 border-none overflow-hidden;
    clip: rect(1px, 1px, 1px, 1px);
    height: 1px;
    width: 1px;
  }
  .payment-table tbody,
  .payment-table tr,
  .payment-table th,
  .payment-table td {
    @apply block text-left whitespace-normal;
  }
  .payment-table tr {
    @apply p-4 rounded-lg;
  }
  .payment-table tr td,
  .payment-table tr th {
    @apply p-2 overflow-hidden relative align-top w-full whitespace-normal;
  }

  .payment-table td[data-header]:before {
    @apply block float-left w-1/2 text-secondary-100 text-left font-bold;
    content: attr(data-header);
  }
  .payment-table td[data-header] > * {
    @apply block w-1/2 float-right clear-right pl-4 mt-0;
  }
  .payment-table td[data-header]:after {
    @apply absolute top-0 left-0 w-1/2 block;
    content: "";
    padding-bottom: 200%;
  }
}

</style>
